"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonHelper = void 0;
var hepler_abstract_1 = require("./hepler-abstract");
var common_file_1 = __importDefault(require("../file/common-file"));
var CommonHelper = /** @class */ (function (_super) {
    __extends(CommonHelper, _super);
    function CommonHelper() {
        return _super.call(this) || this;
    }
    CommonHelper.prototype.getDeviceId = function () {
        var deviceId = this.device_id || window.localStorage.getItem('kdocs_ai_device_id');
        if (!deviceId) {
            deviceId = this.generateRandomString(32, 16);
            window.localStorage.setItem('kdocs_ai_device_id', deviceId);
            this.device_id = deviceId;
        }
        return deviceId;
    };
    CommonHelper.prototype.getAiServerHeaders = function () {
        var version = require('../../../package.json').version;
        return {
            'x-client-type': 'kdocs-web',
            'x-component': common_file_1.default.getOfficeType(),
            'x-client-ver': version,
            'x-client-chan': version,
            'x-device-id': this.getDeviceId(),
            'x-client-lang': 'zh',
            'x-product': 'KDOCS',
            'content-type': 'application/json',
            'x-client-request-id': this.genClientRequestId(),
        };
    };
    CommonHelper.prototype.getAiServerHeadersV5 = function () {
        var version = require('../../../package.json').version;
        return {
            'x-client-request-id': this.genClientRequestId(),
            'x-client-product': 'KDOCS',
            'x-client-type': 'kdocs-web',
            'x-client-version': version,
            'x-client-channel': version,
            'x-client-language': 'zh-CN',
            'x-client-component': common_file_1.default.getOfficeType(),
            'x-client-device-id': this.getDeviceId(),
        };
    };
    return CommonHelper;
}(hepler_abstract_1.HelperAbtract));
exports.CommonHelper = CommonHelper;
exports.default = new CommonHelper();
